import { toast } from "react-toastify";

export const showToast = (message, type="error") => {
  toast(message, {
    position: "top-right",
    type: type,
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};
